<template>
    <div>
        <!-- <headLine></headLine> -->
        <div class="elder_manage_title">
            <p class="title">话务小结统计</p>
        </div>
        <slot name="statistics"></slot>
        <div class="search_wrapper">
            <div class="search_head">
                <span>查询条件</span>
                <!-- <el-button
                    style="float: right; padding: 3px 0; color: #000"
                    type="text"
                    @click="Reset"
                >
                    <i class="el-icon-refresh"></i>
                    刷新页面
                </el-button> -->
                <i
                    class="searchDomw"
                    @click="isSearchContent = !isSearchContent"
                    :class="
                        isSearchContent == true
                            ? 'el-icon-arrow-up'
                            : 'el-icon-arrow-down'
                    "
                ></i>
            </div>
            <div class="search_content" v-show="isSearchContent">
                <div class="search_inline">
                    <el-form label-width="90px" ref="form" :model="form">
                        <el-row>
                            <el-col :span="5">
                                <el-form-item label="操作员：">
                                    <el-input
                                        clearable
                                        placeholder="请输入"
                                        v-model="form.updateman"
                                    ></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="5">
                                <el-form-item label="用户姓名：">
                                    <el-input
                                        clearable
                                        placeholder="请输入"
                                        v-model="form.callman"
                                    ></el-input>
                                </el-form-item>
                            </el-col>

                            <el-col :span="14">
                                <el-form-item label="日期：">
                                    <el-date-picker
                                        v-model="form.startTimeStr"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        type="datetime"
                                        placeholder="请选择开始时间"
                                    ></el-date-picker>
                                    <span style="margin: 0 5px">至</span>
                                    <el-date-picker
                                        v-model="form.endTimeStr"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        type="datetime"
                                        placeholder="请选择结束时间"
                                    ></el-date-picker>
                                </el-form-item>
                            </el-col>

                            <el-col :span="5">
                                <el-form-item label="电话类型：">
                                    <el-select
                                        clearable
                                        placeholder="请选择"
                                        v-model="form.callType"
                                    >
                                        <el-option
                                            label="呼入"
                                            value="0"
                                        ></el-option>
                                        <el-option
                                            label="呼出"
                                            value="1"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="3" :offset="2">
                                <el-button
                                    type="primary"
                                    class="searchBtns"
                                    @click="getlist"
                                    >查询</el-button
                                >
                            </el-col>
                        </el-row>
                    </el-form>
                </div>
                <!-- <div class="arrowDown">
                    <i
                        :class="
                            isSearchContent === true
                                ? 'el-icon-arrow-up'
                                : 'el-icon-arrow-down'
                        "
                        style="color: #000"
                        @click="isSearchContent = !isSearchContent"
                    ></i>
                </div> -->
            </div>
        </div>
        <!-- <global-tag>
            <span slot="title">话务小结统计</span>
            <div class="search" slot="search">
                <el-form label-width="90px" ref="form" :model="form">
                    <el-row>
                        <el-col :span="5">
                            <el-form-item label="操作员：">
                                <el-input
                                    clearable
                                    placeholder="请输入"
                                    v-model="form.updateman"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="5">
                            <el-form-item label="用户姓名：">
                                <el-input
                                    clearable
                                    placeholder="请输入"
                                    v-model="form.callman"
                                ></el-input>
                            </el-form-item>
                        </el-col>

                        <el-col :span="14">
                            <el-form-item label="日期：">
                                <el-date-picker
                                    v-model="form.startTimeStr"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="请选择开始时间"
                                ></el-date-picker>
                                <span style="margin: 0 5px">至</span>
                                <el-date-picker
                                    v-model="form.endTimeStr"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    type="datetime"
                                    placeholder="请选择结束时间"
                                ></el-date-picker>
                            </el-form-item>
                        </el-col>

                        <el-col :span="5">
                            <el-form-item label="电话类型：">
                                <el-select
                                    clearable
                                    placeholder="请选择"
                                    v-model="form.callType"
                                >
                                    <el-option
                                        label="呼入"
                                        value="0"
                                    ></el-option>
                                    <el-option
                                        label="呼出"
                                        value="1"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="3" :offset="2">
                            <el-button type="primary" @click="getlist"
                                >查询</el-button
                            >
                        </el-col>
                    </el-row>
                </el-form>
            </div>
        </global-tag> -->
        <div style="height: 20px"></div>
        <div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
            >
                <el-table-column
                    type="index"
                    width="70"
                    label="序号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="callman"
                    label="用户姓名"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="loginName"
                    label="用户账号"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <!-- <el-table-column
                    prop="callType"
                    label="通话类型"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.callType == '1'">呼出</span>
                        <span v-else>呼入</span>
                    </template>
                </el-table-column> -->
                <el-table-column
                    prop="totalCount"
                    label="话务小结数量"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="inCount"
                    label="呼入小结数量"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                    prop="outCount"
                    label="呼出小结数量"
                    align="center"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            @click="look(scope.row.callmanid)"
                            >查看</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination_container">
            <el-pagination
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                :current-page.sync="pageNo"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                @size-change="handletableDataSize"
                @current-change="handleTableDataChange"
            ></el-pagination>
        </div>

        <el-dialog
            :close-on-click-modal="false"
            title="话务小结信息"
            :visible.sync="callDetail"
            :before-close="callDetailClose"
        >
            <el-timeline>
                <el-timeline-item
                    v-for="item in callSummaryList"
                    :key="item.id"
                    :timestamp="item.inputtime"
                    icon="el-icon-microphone"
                    color="#368cbe"
                    placement="top"
                >
                    <el-card class="callCard">
                        <h4>{{ item.rectime }}</h4>
                        <p class="phoneBox">用户账户：{{ item.callman }}</p>
                        <p class="phoneBox">来电号码：{{ item.phone }}</p>
                        <p class="playBox">小结信息：{{ item.remark }}</p>
                    </el-card>
                </el-timeline-item>
            </el-timeline>
        </el-dialog>
    </div>
</template>

<script>
import globalTag from "../components/globalTag"
import headLine from "../components/headline"

export default {
    components: {
        globalTag,
        headLine,
    },
    data() {
        return {
            value1: "",
            form: {},
            tableData: [],
            pageSize: 10,
            total: 0,
            pageNo: 1,
            belongAddressId: "1856cf78-bd6a-45bf-afd4-b553f3da443f",
            callDetail: false,
            callmanid: "",
            callSummaryList: [],
            isSearchContent: true,
        }
    },
    mounted() {
        this.getlist()
    },
    methods: {
        Reset() {
            this.form = {}
            this.getlist()
        },
        // 关闭话务小结信息弹窗
        callDetailClose() {
            this.callDetail = false
            this.callSummaryList = []
            this.callmanid = ""
        },
        // 查看
        look(callmanid) {
            this.callDetail = true
            this.callmanid = callmanid
            this.callSummaryAgentDetail()
        },
        // 获取话务小结信息
        callSummaryAgentDetail() {
            this.$http
                .request({
                    url: "/jjyl/callSummary/info/getCallSummaryByCallman",
                    method: "POST",
                    data: {
                        callmanid: this.callmanid,
                    },
                })
                .then((resp) => {
                    if (resp.code == "200") {
                        if (resp.content != null) {
                            console.log(resp)
                            this.callSummaryList = resp.content
                        } else {
                            console.log(resp)
                        }
                    } else if (resp.code == "500") {
                        this.$message(resp.message)
                    }
                })
        },
        // 分页切换
        handletableDataSize(val) {
            this.pageSize = val
            this.getlist()
        },
        // 分页切换
        handleTableDataChange(val) {
            this.pageNo = val
            this.getlist()
        },
        //获取表格数据列表
        getlist() {
            this.$http
                .request({
                    url: "/jjyl/callSummary/info/findList  ",
                    method: "POST",
                    data: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        // belongAddressId: this.belongAddressId,
                        ...this.form,
                    },
                })
                .then((res) => {
                    if (res.code === 200) {
                        if (res.content && res.content) {
                            this.tableData = res.content.list || []
                            this.total = this.tableData.length
                        } else {
                            this.tableData = []
                            this.total = 0
                        }
                    }
                })
        },
    },
}
</script>
<style lang="less" scoped>
.elder_manage_title {
    position: relative;
    width: 100%;
    margin-bottom: 15px;
    &::after {
        position: absolute;
        left: 120px;
        right: 0;
        display: block;
        content: "";
        border-bottom: 1px solid #e4e7ed;
    }
    .title {
        box-sizing: border-box;
        display: inline-block;
        width: 120px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        color: #409eff;
        font-size: 14px;
        border: 1px solid #e4e7ed;
        border-bottom: none;
        border-radius: 4px 4px 0 0;
        box-sizing: border-box;
        background: #ffffff;
    }
}
/deep/ .search_wrapper {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    .search_head {
        background: #fff;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        color: rgb(0, 0, 0);
        border-color: rgb(217, 217, 217);
        padding: 6px 15px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
    }
    .search_content {
        padding: 15px 20px 0px 5px;
        border: 1px solid rgb(217, 217, 217);
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
    }
    .search_inline {
        width: 100%;
    }
    .arrowDown {
        width: 28px;
        height: 28px;
        background: #edf2f0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 50%;
        bottom: -14px;
        transform: translate(-50%, 0px);
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
    }
}
.searchDomw {
    cursor: pointer;
}
</style>
